(() => {
  const originals = new WeakMap();
  const knownLinks = new Set();
  function updateLogoLinks() {
    const disabled = document.querySelector('header-component[data-logo-links-disabled="true"]') !== null;
    const links = new Set(document.querySelectorAll('a[data-ritual-logo-link]'));
    document.querySelectorAll('[data-ritual-logo]').forEach(logo => {
      const parent = logo.closest('a');
      if (parent) links.add(parent);
      logo.querySelectorAll('a').forEach(link => links.add(link));
    });
    links.forEach(link => {
      knownLinks.add(link);
      if (!originals.has(link)) originals.set(link, {
        href: link.getAttribute('href') ?? link.getAttribute('data-logo-home-url'),
        tabindex: link.getAttribute('tabindex'), role: link.getAttribute('role')
      });
    });
    knownLinks.forEach(link => {
      if (!link.isConnected) { knownLinks.delete(link); return; }
      const saved = originals.get(link);
      if (disabled) {
        link.removeAttribute('href');
        link.removeAttribute('tabindex');
        if (link.getAttribute('role') === 'link') link.removeAttribute('role');
        link.setAttribute('data-logo-link-disabled', '');
      } else {
        for (const attr of ['href', 'tabindex', 'role']) {
          if (saved[attr] === null) link.removeAttribute(attr);
          else link.setAttribute(attr, saved[attr]);
        }
        link.removeAttribute('data-logo-link-disabled');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLogoLinks, { once: true });
  else updateLogoLinks();
  document.addEventListener('shopify:section:load', updateLogoLinks);
  document.addEventListener('shopify:section:reorder', updateLogoLinks);
})();
